import { useId, useState } from "react";
import { loginWithPasscode } from "../../utils/adminAuth";
import "../../styles/components/AdminLogin.css";

export default function AdminLogin({ onLogin }) {
  const inputId = useId();
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);
    try {
      const session = loginWithPasscode(passcode);
      if (!session) {
        setError("Invalid passcode.");
        return;
      }
      onLogin?.(session);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <section className="adminLogin" aria-label="Admin login">
      <div className="adminLogin__card">
        <h1 className="adminLogin__title">Admin Access</h1>
        <p className="adminLogin__subtitle">Enter the passcode to view registrations.</p>

        <form className="adminLogin__form" onSubmit={handleSubmit} noValidate>
          <label className="adminLogin__label" htmlFor={inputId}>
            Passcode
          </label>
          <input
            className="adminLogin__input"
            id={inputId}
            type="password"
            value={passcode}
            onChange={(e) => {
              setPasscode(e.target.value);
              if (error) setError("");
            }}
            autoComplete="current-password"
            required
            disabled={isSubmitting}
          />
          {error ? (
            <div className="adminLogin__error" role="alert">
              {error}
            </div>
          ) : null}

          <button className="adminLogin__button" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <div className="adminLogin__hint">URL: `/chicago/admin`</div>
      </div>
    </section>
  );
}

